export function numberWithCommas(
  x: number | string | null | undefined,
): string {
  if (x === null || x === undefined) return "0";

  if (typeof x === "string") {
    x = parseFloat(x);
  }

  if (typeof x !== "number" || isNaN(x)) {
    return "Invalid number";
  }

  return x.toLocaleString(undefined, { maximumFractionDigits: 20 });
}
